// extracted by mini-css-extract-plugin
export default {"container":"generateFirstLetterBox_container__1GU14"};